// Sprint UI-GLOBALE — riga di lista che apre la scheda: clic ovunque o Invio/Spazio da tastiera.
// I comandi già presenti nella riga (pulsanti, link, caselle) eseguono la propria azione e non aprono la scheda.
const INTERATTIVI = "button, a, input, select, textarea, label, [role='checkbox'], [role='button'], [data-no-row-open]";

export function rigaCliccabile(apri) {
  return {
    role: "link",
    tabIndex: 0,
    onClick: (e) => {
      if (e.target.closest(INTERATTIVI)) return;
      apri();
    },
    onKeyDown: (e) => {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); apri(); }
    },
  };
}

export const RIGA_CLS = "cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-blue-500";
